import React, { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import Button from '@mui/material/Button';
import ContainerHeader from '../../../../components/ContainerHeader';
import moment from 'moment';
import ButtonGroup from '@mui/material/ButtonGroup';
import customHead from 'constants/customHead'
import AdminContainer from "containers/AdminContainer";
import Pagination from '@mui/material/Pagination';
import PaginationCount from "app/routes/components/PaginationCount";
import axios from 'axios';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Field, Form } from 'react-final-form';
import appConfig from '../../../../constants/config';
import { NotificationManager } from 'react-notifications';
import { required } from 'constants/validations';
import TextArea from 'components/TextArea';
import CircularProgress from '@mui/material/CircularProgress';
import { useLocation, useParams } from "react-router";
//
import { Area, AreaChart, ResponsiveContainer } from 'recharts';
// import SalesStatistic from 'components/dashboard/eCommerce/SalesStatistic';
// import MonthlySalesStatistic from 'components/dashboard/eCommerce/MonthlySalesStats';
// import { getAdminmonthlySalesStats, getAdminDashboardStats, getAdminsalesStats } from 'actions/admin';
// import Top5Buyers from './Top5Buyers';
// import Top5Sellers from './Top5Sellers';
// import CardMenu from 'components/dashboard/Common/CardMenu';
import { increamentData } from "../../adminDashboard/routes/Dashboard/mdata";
import '../../sellerDetails/SalesStatistic';
import AppConfig from "../../../../constants/config";
import { Link } from "react-router-dom";
//
// import DatePicker from "react-datepicker";
import TextField from '@mui/material/TextField';
import dayjs from "dayjs";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Col, Row } from "reactstrap";
// REMOVE: import { useSelector } from 'react-redux';
import { FormGroup, Label, Input } from 'reactstrap';
import ReactStrapSelectField from '../../components/reactstrapSelectField';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';



function Crm(props) {

  const [state, setState] = useState({
    edit: false,
    hide: false,
    delete: false,
    add: false,
    val: '',
    selectedData: {},
    checkedA: false,
  })
  const [loading, setLoading] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const [rowLoading, setRowLoading] = useState(false);

  const [orderRelatedData, setOrderRelatedData] = useState({});
  const [ticketRelatedData, setTicketRelatedData] = useState({});
  const [tableData, setTableData] = useState([]);
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [selectedTableDate, setSelectedTableDate] = useState(dayjs());
  const [dialogopen, setDialogopen] = useState(false);
  const [roleData, setRoleData] = useState({});
  const [selectedBuyer, setSelectedBuyer] = useState(null);
  const [callLog, setCallLog] = useState([]);
  const [formInitialValues, setFormInitialValues] = useState({
    call_status: '',
    call_report: ''
  });
  const { id } = useParams();

  const [visibleCount, setVisibleCount] = useState(() => {
    const savedCount = localStorage.getItem(`visibleCount_${id}`);
    return parseInt(savedCount) || 20;
  });

  let minDate;
  if (roleData?.isReportingManager) {
    minDate = dayjs().subtract(7, 'day').startOf('day');
  } else if (roleData?.isAdmin) {
    minDate = dayjs().subtract(12, 'month').startOf('day');
  } else {
    minDate = dayjs();
  }

  const location = useLocation();
  const receivedData = location.state?.someData;

  const addBuyerRow = async (RM_id, selectedTableDate) => {
    try {
      if(tableData.length < 40){
        setVisibleCount(prev => {
          const newCount = prev + 1;
          localStorage.setItem(`visibleCount_${RM_id}`, newCount);
          return newCount;
        });
      }else{
        await getListOf20Buyers(RM_id, selectedTableDate, true, controller.signal);
        setVisibleCount(prev => {
          const newCount = prev + 1;
          localStorage.setItem(`visibleCount_${RM_id}`, newCount);
          return newCount;
        });
      }

    } catch (error) {
      console.error('Error force refreshing data:', error);
    }
  };

  const handleDateChange = async (date) => {
    setSelectedTableDate(date)
  }

  const columns = [
  {
    name: "SL.",
    label: "SL.",
    options: {
      filter: false,
      sort: false,
      customHeadRender: (o, updateDirection) => {
        return customHead(o, updateDirection);
      },
      setCellHeaderProps: () => ({
        style: { maxWidth: '5px', height: '50px' },
      }),
    }
  },
  {
    name: "company_name",
    label: "Customer Name",
    options: {
      filter: false,
      sort: false,
      customHeadRender: (o, updateDirection) => {
        return customHead(o, updateDirection);
      }
    }
  },
  {
    name: "phone",
    label: "Contact Number",
    options: {
      filter: false,
      sort: false,
      customHeadRender: (o, updateDirection) => {
        return customHead(o, updateDirection);
      }
    }
  },
  {
    name: "total_business",
    label: "Total Business",
    options: {
      filter: false,
      sort: false,
      customHeadRender: (o, updateDirection) => {
        return customHead(o, updateDirection);
      }
    }
  },
  {
    name: "call_status",
    label: "Status",
    options: {
      filter: false,
      sort: false,
      customHeadRender: (o, updateDirection) => {
        return customHead(o, updateDirection);
      }
    }
  },
  {
    name: "call_report",
    label: "Call Report",
    options: {
      filter: false,
      sort: false,
      customHeadRender: (o, updateDirection) => {
        return customHead(o, updateDirection);
      }
    }
  },
  
];


const options = {
  filterType: 'dropdown',
  print: false,
  filter: false,
  download: false,
  selectableRows: 'none',
  selectableRowsOnClick: false,
  selectableRowsHeader: false,
  responsive: 'scrollMaxHeight',
  search: false,
  viewColumns: false,
  rowHover: false,
  rowsPerPage: 50,
  rowsPerPageOptions: [],
  // customFooter: (count, page, rowsPerPage, changeRowsPerPage, changePage) => {
  //   return <div className="p-4 d-flex justify-content-end">
  //     <PaginationCount page={page} rowsPerPage={rowsPerPage} count={count} />
  //     <Pagination count={Math.ceil(count / rowsPerPage)} page={page + 1} onChange={(e, page) => { changePage(page - 1) }} color="primary" />
  //   </div>
  // }
};
  const RM_id = id ? id : "";

  const handleClick = (key, value) => {
    setState((prev) => ({ ...prev, [key]: !state[key], selectedData: value }))
  }

  const handleClickSubmit = (key, value) => {
    console.warn("api call for making it 1 from 0",key, value)
  }
  const handleAddReport = (data) => {
    setDialogopen(true)
    setSelectedBuyer(data)
    setFormInitialValues({
      call_status: data.call_status || '',
      call_report: data.call_report || ''
    });
  }
  const button = (data) => {
    const hasCallLog = data.call_status && data.call_report
    
    return (
      <ButtonGroup color="primary" aria-label="outlined primary button group">
        <Button 
          className={hasCallLog ? 'text-success' : 'text-primary'} 
          onClick={() => handleAddReport(data)}
          title={hasCallLog ? (roleData?.isAdmin ? 'View existing call report' : 'Edit existing call report') : 'Add new call report'}
        >
          {hasCallLog ? ((roleData?.isAdmin || roleData?.isReportingManager) ? 'View Report' : 'Edit Report') : 'Report'}
        </Button>
      </ButtonGroup>
    );
  }

  const getUserRoleInfo = async () => {
    try {
      const result = await axios.get(`${AppConfig.baseUrl}admin/getUserRoleInfo`, {
        headers: {
          'Content-Type': 'application/json',
          'token': localStorage.getItem('admin_token')
        },
      });
      if (result?.data?.error) {
        console.log(result.data.title || 'Error fetching user role');
      } else if (result?.data) {
        setRoleData(result.data.roles);
        return result.data.roles
      }
    } catch (error) {
        console.error('Error fetching CRM permissions:', error);
    }
  };

  const getOrderRelatedData = async (RM_id, monthYear, signal) => {
      try {
        setLoading(true)
        const result = await axios.post(`${AppConfig.baseUrl}admin/getRmData1`, { RM_1: RM_id, monthYear }, {
          headers: {
            'Content-Type': 'application/json',
            'token': localStorage.getItem('admin_token')
          },
          signal
        });
  
        if (result.data.error) {
          NotificationManager.error(result.data.title);
        } else {
          setOrderRelatedData(result.data);
        }
        setLoading(false)
      } catch (error) {
        console.warn('Something went wrong, Please try again');
      }
    };
  
  const getTicketRelatedData = async (RM_id, monthYear, signal) => {
    try {
      const result = await axios.post(`${AppConfig.baseUrl}admin/getRmData2`, { RM_1: RM_id, monthYear }, {
        headers: {
          'Content-Type': 'application/json',
          'token': localStorage.getItem('admin_token')
        },
        signal
      });

      if (result.data.error) {
        NotificationManager.error(result.data.title);
      } else {
        setTicketRelatedData(result.data);
      }
    } catch (error) {
      console.warn('Something went wrong, Please try again');
    }
  };

  const getListOf20Buyers = async (RM_id, selectedTableDate, addMore, signal) => {
    try {
      !addMore && setTableLoading(true);
      addMore && setRowLoading(true);
      const result = await axios.post(`${AppConfig.baseUrl}admin/getListOf20Buyers`, { RM_1: RM_id, addMore, selectedTableDate }, {
        headers: {
          'Content-Type': 'application/json',
          'token': localStorage.getItem('admin_token')
        },
        signal
      });
      
      if (result.data.error) {
        NotificationManager.error(result.data.title);
      } else {
        const submittedCount = result.data.inactiveBuyers.filter(item => item.is_submit === true).length;

        if (submittedCount == 0 ) {
          localStorage.setItem(`visibleCount_${RM_id}`, 20);
          setVisibleCount(20)
        }
        setTableData(result.data.inactiveBuyers);
      }
      
      !addMore && setTableLoading(false);
      addMore && setRowLoading(false);
    } catch (error) {
      console.log(error, "catch error")
      setTableLoading(false);
      setRowLoading(false);
    }
  };

  useEffect(() => {
    getUserRoleInfo();
  }, []);

  const onSubmit = async (values) => {
    const payload = {
      ...values,
      buyer_id: selectedBuyer?.buyer_id,
      relationalmanager_id: selectedBuyer?.relationalmanager_id
    };

    try {
      let response = await axios.post(`${AppConfig.baseUrl}admin/saveCallReport`, {
          ...payload,
          call_log_id: selectedBuyer?._id
        }, {
          headers: {
            'token': localStorage.getItem('admin_token')
          }
        });

      if (response.data.error) {
        NotificationManager.error(response.data.title);
      } else {
        NotificationManager.success(response.data.title);
        handleRequestClose();
        getListOf20Buyers(RM_id, selectedTableDate, false, controller.signal);
      }
      setDialogopen(false);
    } catch (error) {
      console.error('Error:', error);
      NotificationManager.error('Something went wrong, Please try again');
      handleRequestClose();
    }
  };
  const handleRequestClose = async () => {
    setDialogopen(false)
    setSelectedBuyer(null);
  }

  const controller = new AbortController();
  useEffect(() => {
    if (!RM_id) return;

    const monthYear = dayjs(selectedDate).format("MMMM YYYY");

    getOrderRelatedData(RM_id, monthYear, controller.signal);
    getTicketRelatedData(RM_id, monthYear, controller.signal);

    return () => controller.abort();
  }, [selectedDate, RM_id]);

  useEffect(() => {
    getListOf20Buyers(RM_id, selectedTableDate, false, controller.signal)

    return () => controller.abort();
  }, [selectedTableDate, RM_id]);

  useEffect(() => {
    if (tableData?.length > 0) {
      const submittedCount = tableData.filter(item => item.is_submit === true).length;
      const savedCount = localStorage.getItem(`visibleCount_${id}`);
      if (submittedCount > 20 && !savedCount) {
        setVisibleCount(submittedCount);
        localStorage.setItem(`visibleCount_${RM_id}`, submittedCount);
      }
    }
  }, [tableData, RM_id]);

  const allHaveCallData = tableData?.length >= 20 &&
    tableData.slice(0, visibleCount).every(
      (item) => item.is_submit === true
    );

  const statusStyle = (status) => {
    return status.includes("Not Connected") ? "text-white bg-danger" : "text-white bg-green";
  }

  var groupData = [];

  tableData.length > 0 && (
    roleData?.isRelationalManager
      ? tableData.slice(0, visibleCount)
      : tableData.filter(item => item.is_submit === true)
  ).map((data, index) => {
    groupData.push([
      index + 1,
      <div>
        {data?.company_name && data.company_name } (
          <a
          href={`/admin/buyers/details/${data.buyer_id}`}
          target="_blank"
          rel="noopener noreferrer"
        >{data?.mdbl_id && data.mdbl_id}
        </a>)
      </div>,
      <div>
        {data.phone && data.phone}
      </div>,
      `₹${Math.floor(data.total_business).toLocaleString('en-IN')}`,
      <div
        key={'recent'}
        className={`badge text-uppercase ${data.call_status ? statusStyle(data.call_status) : 'text-white bg-primary'}`}
      >
        {data.call_status ? data.call_status : "Pending"}
      </div>,
      button(data)
    ]);
  });
  if (rowLoading) {
    groupData.push([
      "",
      "",
      <div style={{ display: "flex", justifyContent: "center" }}>
        <CircularProgress size={20} />
      </div>
    ]);
  }
  return (
    <AdminContainer>
      {orderRelatedData && ticketRelatedData && receivedData &&
        <React.Fragment>
          <ContainerHeader match={props.match} title={`${receivedData?.first_name}`} />
          {loading ?
            <div className="loader-view"
              style={{ height: props.width >= 1200 ? 'calc(100vh - 259px)' : 'calc(100vh - 238px)' }}>
              <CircularProgress />
            </div>
            :
            <>
              <div className="row">
              <Row className="justify-content-end mb-3">
                <Col xs="auto" className="d-flex align-items-center">
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      views={["month", "year"]}
                      value={selectedDate}
                      onChange={(newValue) => {
                        setSelectedDate(newValue);
                      }}
                      label={"Select Month"}
                      maxDate={dayjs()}
                    />
                  </LocalizationProvider>
                </Col>
              </Row>
                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
                  <div className="jr-card jr-card-full">
                    <div className={`jr-fillchart bg-success jr-overlay-fillchart`}>
                      <div className="card-title mb-3">
                        <h3 style={{ color: 'white', marginBottom: '0px' }}>BULK COMBO COUNT</h3>
                      </div>
                      <ResponsiveContainer width="100%" height={75}>
                        <AreaChart data={increamentData}
                          margin={{ top: 0, right: 0, left: 0, bottom: 0 }}>
                          <Area dataKey='pv' strokeWidth={0} stackId="2" stroke='#3a983e' fill='#3a983e'
                            fillOpacity={1} />
                        </AreaChart>
                      </ResponsiveContainer>
                      <div className="jr-fillchart-content">
                        <div className="card-title mb-4">
                          <h3 style={{ color: 'white', marginBottom: '0px' }}>BULK COMBO COUNT</h3>
                        </div>
                        <h2 className="mb-2 jr-fs-xl jr-font-weight-medium">&nbsp;{(orderRelatedData?.bulkOrder_count || 0).toLocaleString('en-IN')}</h2>
                        <p className="mb-0 jr-fs-sm">
                          <span
                            className={`jr-font-weight-medium jr-fs-md jr-chart-up`}>
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
                  <div className="jr-card jr-card-full">
                    <div className={`jr-fillchart bg-pink accent-2 jr-overlay-fillchart`}>
                      <div className="card-title mb-3">
                        <h3 style={{ color: 'white', marginBottom: '0px' }}>Non Bulk Business Count</h3>
                      </div>
                      <ResponsiveContainer width="100%" height={75}>
                        <AreaChart data={increamentData}
                          margin={{ top: 0, right: 0, left: 0, bottom: 0 }}>
                          <Area dataKey='pv' type='monotone' strokeWidth={0} stackId="2" stroke='#da2361'
                            fill='#da2361'
                            fillOpacity={1} />
                        </AreaChart>
                      </ResponsiveContainer>
                      <div className="jr-fillchart-content">
                        <div className="card-title mb-4">
                          <h3 style={{ color: 'white', marginBottom: '0px' }}>Non Bulk Business Count</h3>
                        </div>
                        <h2 className="mb-2 jr-fs-xl jr-font-weight-medium">&nbsp;{(orderRelatedData?.nonBulkOrder_count || 0).toLocaleString('en-IN')}</h2>
                        <p className="mb-0 jr-fs-sm">
                          <span
                            className={`jr-font-weight-medium jr-fs-md jr-chart-up`}>
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
                  <div className="jr-card jr-card-full">
                    <div className={`jr-fillchart bg-info accent-2 jr-overlay-fillchart`}>
                      <div className="card-title mb-3">
                        <h3 style={{ color: 'white', marginBottom: '0px' }}>Open Tickets</h3>
                      </div>
                      <ResponsiveContainer width="100%" height={75}>
                        <AreaChart data={increamentData}
                          margin={{ top: 0, right: 0, left: 0, bottom: 0 }}>
                          <Area dataKey='pv' strokeWidth={0} stackId="2" stroke='#0c8e9f' fill='#0c8e9f'
                            fillOpacity={1} />
                        </AreaChart>
                      </ResponsiveContainer>
                      <div className="jr-fillchart-content">
                        <div className="card-title mb-4">
                          <h3 style={{ color: 'white', marginBottom: '0px' }}>Open Tickets</h3>
                        </div>
                        <h2 className="mb-2 jr-fs-xl jr-font-weight-medium">{(ticketRelatedData?.openTicketCount || 0).toLocaleString('en-IN')}</h2>
                        <p className="mb-0 jr-fs-sm">
                          <span
                            className={`jr-font-weight-medium jr-fs-md jr-chart-up`}>
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
                  <div className="jr-card jr-card-full">
                    <div className={`jr-fillchart bg-indigo accent-2 jr-overlay-fillchart`}>
                      <div className="card-title mb-3">
                        <h3 style={{ color: 'white', marginBottom: '0px' }}>RTO count</h3>
                      </div>
                      <ResponsiveContainer width="100%" height={75}>
                        <AreaChart data={increamentData}
                          margin={{ top: 0, right: 0, left: 0, bottom: 0 }}>
                          <Area dataKey='pv' strokeWidth={0} stackId="2" stroke='#273894' fill="#273894"
                            fillOpacity={1} />
                        </AreaChart>
                      </ResponsiveContainer>
                      <div className="jr-fillchart-content">
                        <div className="card-title mb-4">
                          <h3 style={{ color: 'white', marginBottom: '0px' }}>RTO count</h3>
                        </div>
                        <h2 className="mb-2 jr-fs-xl jr-font-weight-medium">&nbsp;{(orderRelatedData?.rtoOrder_count || 0).toLocaleString('en-IN')}</h2>
                        <p className="mb-0 jr-fs-sm">
                          <span
                            className={`jr-font-weight-medium jr-fs-md jr-chart-up`}>
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
                  <div className="jr-card jr-card-full">
                    <div className={`jr-fillchart bg-success jr-overlay-fillchart`}>
                      <div className="card-title mb-3">
                        <h3 style={{ color: 'white', marginBottom: '0px' }}>BULK COMBO VALUE</h3>
                      </div>
                      <ResponsiveContainer width="100%" height={75}>
                        <AreaChart data={increamentData}
                          margin={{ top: 0, right: 0, left: 0, bottom: 0 }}>
                          <Area dataKey='pv' strokeWidth={0} stackId="2" stroke='#3a983e' fill='#3a983e'
                            fillOpacity={1} />
                        </AreaChart>
                      </ResponsiveContainer>
                      <div className="jr-fillchart-content">
                        <div className="card-title mb-4">
                          <h3 style={{ color: 'white', marginBottom: '0px' }}>BULK COMBO VALUE</h3>
                        </div>
                        <h2 className="mb-2 jr-fs-xl jr-font-weight-medium">&#8377;&nbsp;{(orderRelatedData?.bulkOrder_value || 0).toLocaleString('en-IN')}</h2>
                        <p className="mb-0 jr-fs-sm">
                          <span
                            className={`jr-font-weight-medium jr-fs-md jr-chart-up`}>
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
                  <div className="jr-card jr-card-full">
                    <div className={`jr-fillchart bg-pink accent-2 jr-overlay-fillchart`}>
                      <div className="card-title mb-3">
                        <h3 style={{ color: 'white', marginBottom: '0px' }}>Non Bulk Business Value</h3>
                      </div>
                      <ResponsiveContainer width="100%" height={75}>
                        <AreaChart data={increamentData}
                          margin={{ top: 0, right: 0, left: 0, bottom: 0 }}>
                          <Area dataKey='pv' type='monotone' strokeWidth={0} stackId="2" stroke='#da2361'
                            fill='#da2361'
                            fillOpacity={1} />
                        </AreaChart>
                      </ResponsiveContainer>
                      <div className="jr-fillchart-content">
                        <div className="card-title mb-4">
                          <h3 style={{ color: 'white', marginBottom: '0px' }}>Non Bulk Business Value</h3>
                        </div>
                        <h2 className="mb-2 jr-fs-xl jr-font-weight-medium">&#8377;&nbsp;{(orderRelatedData?.nonBulkOrder_value || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</h2>
                        <p className="mb-0 jr-fs-sm">
                          <span
                            className={`jr-font-weight-medium jr-fs-md jr-chart-up`}>
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
                  <div className="jr-card jr-card-full">
                    <div className={`jr-fillchart bg-info accent-2 jr-overlay-fillchart`}>
                      <div className="card-title mb-3">
                        <h3 style={{ color: 'white', marginBottom: '0px' }}>Daily Action Count</h3>
                      </div>
                      <ResponsiveContainer width="100%" height={75}>
                        <AreaChart data={increamentData}
                          margin={{ top: 0, right: 0, left: 0, bottom: 0 }}>
                          <Area dataKey='pv' strokeWidth={0} stackId="2" stroke='#0c8e9f' fill='#0c8e9f'
                            fillOpacity={1} />
                        </AreaChart>
                      </ResponsiveContainer>
                      <div className="jr-fillchart-content">
                        <div className="card-title mb-4">
                          <h3 style={{ color: 'white', marginBottom: '0px' }}>Daily Action Count</h3>
                        </div>
                        <h2 className="mb-2 jr-fs-xl jr-font-weight-medium">{(ticketRelatedData?.dailyActionCount || 0).toLocaleString('en-IN')}</h2>
                        <p className="mb-0 jr-fs-sm">
                          <span
                            className={`jr-font-weight-medium jr-fs-md jr-chart-up`}>
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
                  <div className="jr-card jr-card-full">
                    <div className={`jr-fillchart bg-indigo accent-2 jr-overlay-fillchart`}>
                      <div className="card-title mb-3">
                        <h3 style={{ color: 'white', marginBottom: '0px' }}>RTO value</h3>
                      </div>
                      <ResponsiveContainer width="100%" height={75}>
                        <AreaChart data={increamentData}
                          margin={{ top: 0, right: 0, left: 0, bottom: 0 }}>
                          <Area dataKey='pv' strokeWidth={0} stackId="2" stroke='#273894' fill="#273894"
                            fillOpacity={1} />
                        </AreaChart>
                      </ResponsiveContainer>
                      <div className="jr-fillchart-content">
                        <div className="card-title mb-4">
                          <h3 style={{ color: 'white', marginBottom: '0px' }}>RTO value</h3>
                        </div>
                        <h2 className="mb-2 jr-fs-xl jr-font-weight-medium">&#8377;&nbsp;{(orderRelatedData?.rtoOrder_value || 0).toLocaleString('en-IN')}</h2>
                        <p className="mb-0 jr-fs-sm">
                          <span
                            className={`jr-font-weight-medium jr-fs-md jr-chart-up`}>
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="d-flex justify-end"
                style={{ marginBottom: '10px', marginRight: '0px', justifyContent: "end" }}
              >
                {!roleData?.isRelationalManager && 
                <Row className="justify-content-end mb-3">
                  <Col xs="auto" className="d-flex align-items-center">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        value={selectedTableDate}
                        onChange={(newValue) => {
                          handleDateChange(newValue)
                        }}
                        label={"Select Date"}
                        minDate={minDate}
                          maxDate={dayjs()}
                      />
                    </LocalizationProvider>
                  </Col>
                </Row>
                }
                {!roleData?.isAdmin &&
                !roleData?.isReportingManager &&
                roleData?.isRelationalManager && 
                <Button
                  variant="outlined"
                  color="primary"
                  className="ml-2"
                  onClick={() => {
                    // const monthYear = dayjs(selectedDate).format("MMMM YYYY");
                    addBuyerRow(RM_id, selectedTableDate);
                  }}
                  disabled={tableLoading || !allHaveCallData}
                  style={{ marginLeft: '10px' }}
                >
                  Add next
                </Button>
                }
              </div>
              {tableLoading ? 
              <div className="loader-view"
                style={{ height: props.width >= 1200 ? 'calc(70vh - 259px)' : 'calc(70vh - 238px)' }}>
                <CircularProgress />
              </div> :
              <>
              <MUIDataTable
                title={
                  <div style={{ marginLeft: "-10px", marginTop: "10px"}}>
                    <h3>Customer Engagement Calls</h3>
                  </div>
                }
                data={groupData}
                columns={columns}
                options={options}
              />
              {/* add call log dialog */}
                  <Dialog open={dialogopen} onClose={handleRequestClose}
                    fullWidth={true}
                    maxWidth={'md'}>
                    
                      <Form
                      key={selectedBuyer?.buyer_id || 'new'} // Force re-render when buyer changes
                        onSubmit={onSubmit}
                        initialValues={formInitialValues}
                        render={({ handleSubmit, values }) => {
                          const isEditing = values.call_status && values.call_report
                          return (
                            <form noValidate onSubmit={handleSubmit} autoComplete="off">
                              <DialogTitle>
                                {/* Add Call Report */}
                                {isEditing ?(roleData?.isAdmin ? 'View call report' : 'Edit call report') : 'Add call report'}
                                {selectedBuyer && (
                                  <div style={{ fontSize: '14px', color: '#666', marginTop: '5px' }}>
                                    Customer: {selectedBuyer?.company_name}
                                  </div>
                                )}
                              </DialogTitle>
                            <DialogContent>
                              <Row>
                                <Col xs={12} md={6} sm={12} xl={4} lg={4}>
                                  <FormGroup>
                                    <Field id="call_status" name="call_status" type="select"
                                      validate={required}
                                      disabled={!roleData?.isRelationalManager}
                                      component={ReactStrapSelectField} label={"Call Status"}
                                    >
                                      <option value="" disabled>Select Call Status</option>
                                      <option
                                        value='Connected'>Connected</option>
                                      <option
                                        value='Not Connected'>Not Connected</option>
                                    </Field>
                                  </FormGroup>
                                </Col>
                              </Row>
                              <Row>
                                  <Col xs={12}>
                                    <Label for="call_report">Call Report</Label>
                                    <Field
                                      id="call_report"
                                      name="call_report"
                                      component={TextArea}
                                      validate={required}
                                      disabled={!roleData?.isRelationalManager}
                                      rows={4}
                                    />
                                  </Col>
                              </Row>
                            </DialogContent>
                              {
                                !roleData?.isAdmin &&
                                !roleData?.isReportingManager &&
                                roleData?.isRelationalManager &&
                                <DialogActions className="pr-4">
                                  <Button onClick={handleRequestClose} color='secondary' >
                                    Cancel
                                  </Button>
                                  <Button type='submit' color='primary' disabled={loading} >
                                    {isEditing ? 'Update Report' : 'Add Report'}
                                  </Button>
                                </DialogActions>
                              }
                          </form>
                        );
                        }}
                      />
                  </Dialog>
              </>
              }
            </>
          }
        </React.Fragment>}
    </AdminContainer>
  );
}

export default Crm;